var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoposadzekIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.28 54.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.54,20.92l3.24-3.91h-7.59V0h-15.08v17h-7.59s3.24,3.91,3.24,3.91L0,32.82l27.64,21.23,27.64-21.23-15.74-11.91ZM21.81,18.72V1.71h11.65v17h5.66l-11.49,13.88-11.49-13.88h5.66Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoposadzekIcon);
export default __webpack_public_path__ + "static/media/Do posadzek_icon.041e4595527cf73455a10b3405a2f26e.svg";
export { ForwardRef as ReactComponent };